import { ChannelNames, preferredChannelRoleByVisualType, VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
export const getPreferredChannelForMeasure = visual => {
  var _measureChannelEntrie;
  const visualType = visual.type;
  const channelRoles = preferredChannelRoleByVisualType.get(visualType);
  if (visualType === VisualTypes.TABLE) {
    return ChannelNames.COLUMNS;
  }
  const measureChannelEntries = channelRoles.entrySeq().filter(([__, role]) => role === 'MEASURE');
  const multiMeasureEntry = measureChannelEntries.find(([channelName]) => channelName.toLowerCase().includes('multi'));
  return (multiMeasureEntry ? multiMeasureEntry[0] : (_measureChannelEntrie = measureChannelEntries.first()) === null || _measureChannelEntrie === void 0 ? void 0 : _measureChannelEntrie[0]) || null;
};
export const getPreferredChannelForDimension = visual => {
  var _dimensionChannelEntr;
  const visualType = visual.type;
  const channelRoles = preferredChannelRoleByVisualType.get(visualType);
  if (visualType === VisualTypes.TABLE) {
    return ChannelNames.COLUMNS;
  }
  const dimensionChannelEntries = channelRoles.entrySeq().filter(([__, role]) => role === 'DIMENSION');
  return ((_dimensionChannelEntr = dimensionChannelEntries.first()) === null || _dimensionChannelEntr === void 0 ? void 0 : _dimensionChannelEntr[0]) || null;
};